/**
 * Created by Reda on 21.08.2024
 */

const WindowOffer = function (parentNode, options) {
    this.options = options || {};
    this.parentNode = parentNode;
    this.positioningStartOffset = options.positioningStartOffset || 0;

    if (PackOfferComponent.checkBundles(options.bundle)) {
        const packView = this.packView = new PackOfferComponent(options);
        parentNode.addChild(packView, 2);
    }

    this.updatePackPosition();
    if (!this.isPackVisible()) {
        this.addOfferButton();
    }
};

WindowOffer.prototype.createOfferButton = function () {
    this.offerButton = new OfferButtonComponent(this.options);
    return this.offerButton;
};

WindowOffer.prototype.removeOfferButton = function () {
    if (this.offerButton) {
        this.offerButton.removeFromParent();
        this.offerButton = undefined;
    }
};

WindowOffer.prototype.addOfferButton = function () {
    if (!this.offerButton) {
        this.offerButton = this.createOfferButton();
        this.parentNode.addChild(this.offerButton, 2);
        this.offerButton.show();
    }
};

WindowOffer.prototype.updatePackPosition = function () {
    if (!this.packView) {
        return;
    }

    const packStyles = this.packView.getStyles();
    const sceneSize = cleverapps.resolution.getSceneSize();

    const dx = sceneSize.width / 2 + this.positioningStartOffset;
    this.packView.setAlignment({
        x: { align: "left", dx: dx + packStyles.offsetX },
        y: { align: "bottom", dy: packStyles.offsetY - cleverapps.resolution.getSafePadding().bottom }
    });
};

WindowOffer.prototype.isPackVisible = function () {
    if (!this.packView) {
        return false;
    }
    const packStyles = this.packView.getStyles();
    const sceneSize = cleverapps.resolution.getSceneSize();
    const isVisible = (this.packView.x + (this.packView.pack.width / 2) * (packStyles.spaceRequired / 100)) < sceneSize.width;
    return isVisible && packStyles.visibleResolutionModes.indexOf(cleverapps.resolution.mode) !== -1;
};

WindowOffer.prototype.update = function (animate) {
    if (this.expired) {
        return;
    }

    this.updatePackPosition();

    if (!this.shown) {
        if (this.packView) {
            this.packView.hide(animate);
        }
        this.removeOfferButton();
        return;
    }

    if (this.isPackVisible()) {
        if (this.packView) {
            this.packView.show(animate);
        }
        this.removeOfferButton();
    } else {
        if (this.packView) {
            this.packView.hide(animate);
        }
        this.addOfferButton();
    }
};

WindowOffer.prototype.show = function () {
    this.shown = true;
    this.update(true);
};

WindowOffer.prototype.hide = function (fromWindow) {
    this.shown = false;
    this.update(!fromWindow);
};

WindowOffer.prototype.getOverlapNode = function () {
    return this.offerButton || (this.packView && this.packView.getOverlapNode());
};

WindowOffer.prototype.expireOffer = function () {
    this.expired = true;

    this.removeOfferButton();

    if (this.packView) {
        this.packView.removeFromParent();
        this.packView = undefined;
    }
};
